import { assignIfSupported, BUTTON_THEMES, CTA_TYPE } from './ModelHelpers';

export class CancelStepCta {
  constructor(data) {
    Object.assign(this, {
      message: data.message,
      spacing: data.spacing, // Adds to bottom, nullable
      theme: assignIfSupported(data.theme, Object.values(BUTTON_THEMES)), // Currently we only support themes for buttons, nullable
      type: assignIfSupported(data.type, Object.values(CTA_TYPE)), // nullable
      url: data.url ? data.url : null,
    });
  }
}
